const autoPaymentStrings = {
  headerTitle: 'Auto-payment',
  title: 'Autopay',
  body: "You don't need to pay us back until {{dueDate}}. Choose a date for autopay from your Varo Bank Account between {{minDate}} - {{maxDate}}.",
  bodyV2:
    'You don’t need to pay us back until {{dueDate}}. Choose an autopay date between {{minDate}} - {{maxDate}} and payment method.',
  dateFieldTitle: 'Autopay date',
  linkCopy: 'What if I can’t meet the autopay date?',
  buttons: {
    calendar: 'Continue',
    screen: 'Continue',
  },
  note: 'Your due date is {{dueDate}}, please select an available date above for autopay.',
  dateError: 'Please enter a valid date.',
  methodTitle: 'Payment method',
  dateTitle: 'Autopay date',
  paymentMethodPlaceholder: 'Select your payment method',
  datePlaceholder: 'MM/DD/YYYY',
};

export default autoPaymentStrings;
